const WorkspaceNav = ({ groups, value, onChange, ariaLabel = 'Workspace navigation' }) => (
  <nav className="sa-workspace-nav" aria-label={ariaLabel}>
    {groups.map((group) => <section key={group.label}><h2>{group.label}</h2><div>{group.items.map(([key, label]) => <button key={key} type="button" aria-current={value === key ? 'page' : undefined} className={value === key ? 'is-active' : ''} onClick={() => onChange(key)}>{label}</button>)}</div></section>)}
  </nav>
);

export default WorkspaceNav;
